import { getStorage, GROUPS, setGroupValue } from 'helpers/storage';

export const getSortFromStorage = () => getStorage().getIn([GROUPS.booking, 'sort']);
export const setSortToStorage = sort => setGroupValue(
  GROUPS.booking,
  { sort }
);
